import React, { useState } from 'react';
import moment from 'moment-timezone';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { useIntl, defineMessages } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { parse, stringify } from '../../utils/UrlUtil';


const messages = defineMessages({
  startDate: { id: 'placeholder.startWith', defaultMessage: 'Start date' },
  endDate: { id: 'placeholder.endWith', defaultMessage: 'End date' },
});

const TransfersTableHeader = () => {
  const history = useHistory();
  const location = { history };

  const { formatMessage } = useIntl();

  const params = parse(location.search);

  const DEFAULT_FILTER_STATE = {
    query: '',
    from: undefined,
    to: undefined,
    ...params.filter,
  };

  const [filter, setFilter] = useState(DEFAULT_FILTER_STATE);

  /**
   * Get old URL and:
   * - parse query params
   * - merge new param values
   * - stringify query params
   * - push new url
   */
  const onQueryVariableChange = (newFilter) => {
    // build the filter
    const updatedFilter = { ...newFilter };

    // handle date filter
    if (updatedFilter.from) {
      const fromDate = moment(updatedFilter.from).format('YYYY-MM-DD');
      updatedFilter.from = fromDate;
    }

    if (updatedFilter.to) {
      const toDate = moment(updatedFilter.to).format('YYYY-MM-DD');
      updatedFilter.to = toDate;
    }

    const search = stringify({
      ...params,
      filter: updatedFilter,
    });

    // update url with the new search, keep the rest of the values
    history.push({
      ...location,
      search,
    });
  };

  /**
   * Update the filter Query.
   */
  const onChangeQueryText = (event) => {
    const newFilter = {
      ...filter,
      query: event.currentTarget.value,
    };

    setFilter(newFilter);

    onQueryVariableChange(newFilter);
  };

  const onDateFilterChange = (event, dateFilter) => {
    const newFilter = {
      ...filter,
      [dateFilter]: event.value,
    };

    setFilter(newFilter);

    onQueryVariableChange(newFilter);
  };

  const start = formatMessage(messages.startDate);
  const end = formatMessage(messages.endDate);

  const fromFilter = filter.from ? new Date(filter.from) : null;
  const toFilter = filter.to ? new Date(filter.to) : null;

  return (
    <>
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-md-4">
          <div className="p-inputgroup">
            <InputText
              value={filter.query}
              onChange={onChangeQueryText}
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  onQueryVariableChange(filter);
                }
              }}
            />
            <Button
              icon="pi pi-search"
              // For search we have a search button.
              // The state is already updated. We just upate the url
              onClick={() => onQueryVariableChange(filter)}
            />
          </div>
        </div>
        <div className="p-col-12 p-md-4">
          <Calendar
            value={fromFilter}
            onChange={(event) => {
              onDateFilterChange(event, 'from');
            }}
            readOnlyInput
            showIcon
            showButtonBar
            dateFormat="yy-M-dd"
            placeholder={start}
          />
        </div>
        <div className="p-col-12 p-md-4">
          <Calendar
            value={toFilter}
            onChange={(event) => {
              onDateFilterChange(event, 'to');
            }}
            readOnlyInput
            showIcon
            showButtonBar
            dateFormat="yy-M-dd"
            placeholder={end}
          />
        </div>
      </div>
    </>
  );
};

export default TransfersTableHeader;
